export enum PresenceStatusTypes {
    Online = 0,
    Offline = 1,
    Busy = 2,
    Out = 3,
    Unknown = 99
}

export interface IPresence {
    PresenceStatus: PresenceStatusTypes;
    AdminID: number;
    AdminName: string;
    Email: string;
}

export class PresenceArray extends Array<Presence>  {

    constructor(...items: Presence[]) {
        super(...items);
        Object.setPrototypeOf(this, PresenceArray.prototype);
    }

}

export class Presence implements IPresence {
    public PresenceStatus: PresenceStatusTypes;
    public AdminID: number;
    public AdminName: string;
    public Email: string;
}
